module.exports = __webpack_public_path__ + "img/bind-failed-icon.2d252a82.png";